<template>
    <div>
        <el-drawer :destroy-on-close="true" :append-to-body="true" title="Ayarlar" :visible.sync="settings"
            :with-header="false">
            <div class="row" style="padding: 50px">
                <div class="col-md-12">
                    <label for="">{{ $t("module.speed") }}</label>
                    <el-slider :disabled="lock" v-model="speed" :step="1" :min="1" :max="speeds.length"
                        show-stops></el-slider>
                </div>
                <div class="col-md-12 mb-3">
                    <label class="dark-inverted d-block" for="">Önce Soruyu Oku</label>
                    <el-switch style="margin-top: 8px" v-model="titleFirst" :active-text="$t('module.yes')"
                        :active-value="true" :inactive-value="false" :inactive-text="$t('module.no')" :disabled="lock">
                    </el-switch>
                </div>
                <div class="col-md-12 mb-3">
                    <label class="dark-inverted d-block" for="">Soruyu Sesli Oku</label>
                    <el-switch style="margin-top: 8px" v-model="read" :active-text="$t('module.yes')" :active-value="true"
                        :inactive-value="false" :inactive-text="$t('module.no')" :disabled="lock">
                    </el-switch>
                </div>
                <div class="col-md-12 mb-3">
                    <label class="dark-inverted d-block" for="">Okunan Kelimeyi Gizle</label>
                    <el-switch style="margin-top: 8px" v-model="okunaniSil" :active-text="$t('module.yes')"
                        :active-value="true" :inactive-value="false" :inactive-text="$t('module.no')">
                    </el-switch>
                </div>

                <div class="col-md-12 mt-4">
                    <label for="" class="dark-inverted">Stil</label>
                    <el-radio-group v-model="stil">
                        <el-radio :label="'normal'">Arkaplanı Vurgula</el-radio>
                        <el-radio :label="'alticizik'">Altını Çiz</el-radio>
                        <el-radio :label="'etraficizik'">Etrafını Çiz</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </el-drawer>
        <div id="goz_esnetme" v-loading="lock">
            <paused v-if="pause" @click="
          $root.$emit('pause', !pause);
          pause = false;
        "></paused>
            <a href="javascript:;" @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        " class="pause">
                <i :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>
            </a>
            <h1 v-if="totalWord != 0 && totalDuration != 0" style="
          position: absolute;
          top: -30px;
          left: 0px;
          font-size: 20px;
          font-weight: bold;
          color: silver;
        ">
                {{ parseInt((totalWord / totalDuration) * 60) }}
                Kelime/Dakika
            </h1>
            <a href="javascript:;" v-if="config == null || config == undefined" @click.stop="settings = true"
                class="settings">
                <i class="el-icon-setting"></i>
            </a>

            <div id="question" style="padding: 25px; font-family: Roboto; width: 100%" v-if="question">
                <div v-if="titleFirst" style="
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            flex-direction: row;
            margin-bottom: 15px;
            width: 100%;
          ">
                    <span style="
              padding-right: 2.5px;
              padding-left: 2.5px;
              display: inline-block;
              font-weight: bold;
              font-size: 18px;
            " :style="getSpanStyle(index, 0)" v-for="(i, index) in question.title">{{ i }}</span>
                </div>
                <div style="
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            flex-direction: row;
            width: 100%;
          ">
                    <template v-for="(i, index) in question.description">
                        <div v-if="i.indexOf('<n>') != -1" style="width: 100%; height: 1px"></div>
                        <span style="
                padding-right: 2.5px;
                padding-left: 2.5px;
                display: inline-block;
                font-size: 16px;
              " :style="getSpanStyle(index, 1)" v-html="
                i.replace(/<nl\s*[\/]?>/gi, '\n').replace(/<n\s*[\/]?>/gi, '\n')
              "></span>
                        <div v-if="i.indexOf('<nl>') != -1" style="width: 100%; height: 30px"></div>
                    </template>
                </div>

                <div style="
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            flex-direction: row;
            margin-top: 15px;
            width: 100%;
          ">
                    <span style="
              padding-right: 2.5px;
              padding-left: 2.5px;
              display: inline-block;
              font-weight: bold;
              font-size: 18px;
            " :style="getSpanStyle(index, 2)" v-for="(i, index) in question.title">{{ i }}</span>
                </div>

                <ol type="A" style="
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-direction: column;
            margin-top: 20px;
            padding: 0;
            padding-left: 20px;
            width: 100%;
          ">
                    <li style="font-weight: normal; font-size: 16px" v-for="(i, index) in question.options"
                        @click="check(index)" :style="{ backgroundColor: getOptionClass(index) }">
                        <span style="padding-right: 5px; display: inline-block" v-for="(ii, iindex) in i.title"
                            :style="getSpanStyle(iindex, index + 3)">{{ ii }}</span>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
export default {
    name: "SoruEgzersizi",
    props: ["config"],
    data() {
        return {
            levelMap: {
                İlkokul: {
                    path: "ilkokul",
                    max: 26,
                },
                Ortaokul: {
                    path: "ortaokul",
                    max: 26,
                },
                Lise: {
                    path: "lise",
                    max: 26,
                },
                Yetişkin: {
                    path: "yetiskin",
                    max: 26,
                },
                LGS: {
                    path: "lgs",
                    max: 3,
                },
                YKS: {
                    path: "yks",
                    max: 26,
                },
                "Tüm Sınavlara Hazırlık": {
                    path: "sinav",
                    max: 26,
                },
            },
            pause: false,
            speed: 1,
            speeds: [1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2],
            words: [],
            level: 1,
            currentLetter: null,
            lodash: _,
            wrapper: {
                width: 0,
                height: 0,
            },
            startDate: new Date().getTime(),
            endDate: null,
            skip: 0,
            end: false,
            settings: false,
            random: 0,
            autoLevel: 0,
            question: null,
            showOptions: false,
            currentPart: 1,
            currentIndex: 0,
            checkedOption: null,
            showingWordCount: 1,
            titleFirst: false,
            okunaniSil: false,
            stil: "normal",
            audio: {
                title: {},
                description: {},
                o1: {},
                o2: {},
                o3: {},
                o4: {},
                o5: {},
                title2: {},
            },
            lock: false,
            lockTimeout: null,
            read: true,
            totalDuration: 0,
            totalWord: 0,
        };
    },
    mounted() {
        this.wrapper = {
            width: document.getElementById("goz_esnetme").clientWidth,
            height: document.getElementById("goz_esnetme").clientHeight,
        };
    },
    beforeDestroy() {
        clearInterval(this.interval);
        this.interval = null;
        if (this.audio.title && this.audio.title.audio) {
            this.audio.title.audio.pause();
            this.audio.description.audio.pause();
            this.audio.o1.audio.pause();
            this.audio.o2.audio.pause();
            this.audio.o3.audio.pause();
            this.audio.o4.audio.pause();
            if (this.question.options[5] && this.question.options[5].title) {
                this.audio.o5.audio.pause();
            }
        }
    },
    methods: {
        async getTts(text, id, part) {
            return await axios.post("module/ttsWordWithSpeed", {
                text: text
                    .replace("<nl>", "")
                    .replace(/["'“]/g, "")
                    .replace("/[•]/g", "")
                    .replace(/<nl\s*[\/]?>/gi, "")
                    .replace(/<n\s*[\/]?>/gi, ""),
                gender: "male",
                id: `jq` + id + "_" + part + "_" + this.speeds[this.speed - 1],
                speed: this.speeds[this.speed - 1],
            });
        },
        getSpanStyle(index, cPart) {
            if (
                index >= this.currentIndex &&
                index <= this.currentIndex + (this.showingWordCount - 1) &&
                this.currentPart == cPart
            ) {
                return {
                    backgroundColor: this.stil == "normal" ? "silver" : "",
                    opacity:
                        this.okunaniSil &&
                            (this.currentPart > cPart ||
                                (this.currentPart == cPart && index < this.currentIndex))
                            ? 0
                            : 1,
                    borderBottom: this.stil == "alticizik" ? "1px solid silver" : "",
                    border:
                        this.stil == "etraficizik"
                            ? "1px solid silver"
                            : "1px solid transparent",
                };
            } else {
                return {
                    border: "1px solid transparent",
                    opacity:
                        this.okunaniSil &&
                            (this.currentPart > cPart ||
                                (this.currentPart == cPart && index < this.currentIndex))
                            ? 0
                            : 1,
                };
            }
        },
        check(index) {
            this.checkedOption = {
                ...this.question.options[index],
                index,
            };

            setTimeout(() => {
                this.start();
            }, 2500);
        },
        getOptionClass(index) {
            if (this.checkedOption == null) return;
            var option = this.question.options[index];
            if (option.isTrue === true && this.checkedOption.index == index) {
                return "green";
            }
            if (
                this.checkedOption.index == index &&
                this.checkedOption != null &&
                option.isTrue === false
            ) {
                return "red";
            }
            if (
                this.checkedOption.index != index &&
                this.checkedOption != null &&
                option.isTrue === true
            ) {
                return "orange";
            }
            return "";
        },
        async start() {
            if (this.lock) return;
            this.lock = true;

            if (this.audio.title && this.audio.title.audio) {
                this.audio.title2.audio.pause();
                this.audio.title.audio.pause();
                this.audio.description.audio.pause();
                this.audio.o1.audio.pause();
                this.audio.o2.audio.pause();
                this.audio.o3.audio.pause();
                this.audio.o4.audio.pause();
                if (this.question.options[5] && this.question.options[5].title) {
                    this.audio.o5.audio.pause();
                }
            }

            this.totalDuration = 0;
            this.totalWord = 0;

            this.audio = {
                title: {},
                description: {},
                o1: {},
                o2: {},
                o3: {},
                o4: {},
                o5: {},
                title2: {},
            };
            this.currentIndex = 0;
            if (this.titleFirst === true) {
                this.currentPart = 0;
            } else {
                this.currentPart = 1;
            }
            clearInterval(this.interval);
            this.interval = null;
            this.interval = null;
            this.question = this.words[_.random(0, this.words.length - 1)];
            this.totalWord =
                this.question.title.length +
                this.question.description.length +
                this.question.options[0].title.length +
                this.question.options[1].title.length +
                this.question.options[2].title.length +
                this.question.options[3].title.length;
            if (this.question.options.length == 5) {
                this.totalWord += this.question.options[4].title.length;
            }
            this.checkedOption = null;
            this.showOptions = false;

            var res = await this.getTts(
                this.question.title.join(" "),
                this.question.id,
                "title"
            );

            this.audio.title.timePoints = _.orderBy(
                res.data.timepoints.map((k) => {
                    return {
                        ...k,
                        timeSeconds: k.timeSeconds * 1000,
                        markName: parseInt(k.markName),
                    };
                }),
                ["markName"],
                ["ASC"]
            );
            this.audio.title.audio = new Audio(
                "data:audio/mp3;base64," + res.data.sound
            );

            this.audio.title.audio.onloadedmetadata = () => {
                this.totalDuration += this.audio.title.audio.duration;
            };

            this.audio.title.audio.onended = () => {
                this.currentPart += 1;
                this.currentIndex = 0;
                clearInterval(this.interval);
                this.interval = null;

                this.audio.o1.audio.play();
            };
            this.audio.title.audio.onplay = () => {
                this.interval = setInterval(() => {
                    if (this.pause) return;
                    var a = this.audio.title.timePoints
                        .filter(
                            (k) => k.timeSeconds <= this.audio.title.audio.currentTime * 1000
                        )
                        .reverse()[0];

                    this.currentIndex = a ? parseInt(a.markName) : 0;
                }, 5);
            };

            this.audio.title2.timePoints = _.orderBy(
                res.data.timepoints.map((k) => {
                    return {
                        ...k,
                        timeSeconds: k.timeSeconds * 1000,
                        markName: parseInt(k.markName),
                    };
                }),
                ["markName"],
                ["ASC"]
            );
            this.audio.title2.audio = new Audio(
                "data:audio/mp3;base64," + res.data.sound
            );

            this.audio.title2.audio.onloadedmetadata = () => {
                this.totalDuration += this.audio.title2.audio.duration;
            };

            this.audio.title2.audio.onended = () => {
                this.currentPart += 1;
                this.currentIndex = 0;
                clearInterval(this.interval);
                this.interval = null;

                this.audio.description.audio.play();
            };
            this.audio.title2.audio.onplay = () => {
                this.interval = setInterval(() => {
                    if (this.pause) return;
                    var a = this.audio.title2.timePoints
                        .filter(
                            (k) => k.timeSeconds <= this.audio.title2.audio.currentTime * 1000
                        )
                        .reverse()[0];

                    this.currentIndex = a ? parseInt(a.markName) : 0;
                }, 5);
            };

            var res = await this.getTts(
                this.question.description.join(" "),
                this.question.id,
                "description"
            );

            this.audio.description.timePoints = _.orderBy(
                res.data.timepoints.map((k) => {
                    return {
                        ...k,
                        timeSeconds: k.timeSeconds * 1000,
                        markName: parseInt(k.markName),
                    };
                }),
                ["markName"],
                ["ASC"]
            );
            this.audio.description.audio = new Audio(
                "data:audio/mp3;base64," + res.data.sound
            );

            this.audio.description.audio.onloadedmetadata = () => {
                this.totalDuration += this.audio.description.audio.duration;
            };

            this.audio.description.audio.onended = () => {
                this.currentPart += 1;
                this.currentIndex = 0;
                clearInterval(this.interval);
                this.interval = null;
                this.audio.title.audio.play();
            };
            this.audio.description.audio.onplay = () => {
                this.interval = setInterval(() => {
                    if (this.pause) return;
                    var a = this.audio.description.timePoints
                        .filter(
                            (k) =>
                                k.timeSeconds <= this.audio.description.audio.currentTime * 1000
                        )
                        .reverse()[0];

                    this.currentIndex = a ? parseInt(a.markName) : 0;
                }, 5);
            };

            var res = await this.getTts(
                this.question.options[0].title.join(" "),
                this.question.id,
                "o1"
            );

            this.audio.o1.timePoints = _.orderBy(
                res.data.timepoints.map((k) => {
                    return {
                        ...k,
                        timeSeconds: k.timeSeconds * 1000,
                        markName: parseInt(k.markName),
                    };
                }),
                ["markName"],
                ["ASC"]
            );
            this.audio.o1.audio = new Audio(
                "data:audio/mp3;base64," + res.data.sound
            );

            this.audio.o1.audio.onloadedmetadata = () => {
                this.totalDuration += this.audio.o1.audio.duration;
            };

            this.audio.o1.audio.onended = () => {
                this.currentPart += 1;
                this.currentIndex = 0;
                clearInterval(this.interval);
                this.interval = null;
                this.audio.o2.audio.play();
            };
            this.audio.o1.audio.onplay = () => {
                this.interval = setInterval(() => {
                    if (this.pause) return;
                    var a = this.audio.o1.timePoints
                        .filter(
                            (k) => k.timeSeconds <= this.audio.o1.audio.currentTime * 1000
                        )
                        .reverse()[0];

                    this.currentIndex = a ? parseInt(a.markName) : 0;
                }, 5);
            };

            var res = await this.getTts(
                this.question.options[1].title.join(" "),
                this.question.id,
                "o2"
            );

            this.audio.o2.timePoints = _.orderBy(
                res.data.timepoints.map((k) => {
                    return {
                        ...k,
                        timeSeconds: k.timeSeconds * 1000,
                        markName: parseInt(k.markName),
                    };
                }),
                ["markName"],
                ["ASC"]
            );
            this.audio.o2.audio = new Audio(
                "data:audio/mp3;base64," + res.data.sound
            );

            this.audio.o2.audio.onloadedmetadata = () => {
                this.totalDuration += this.audio.o2.audio.duration;
            };

            this.audio.o2.audio.onended = () => {
                this.currentPart += 1;
                this.currentIndex = 0;
                clearInterval(this.interval);
                this.interval = null;
                this.audio.o3.audio.play();
            };
            this.audio.o2.audio.onplay = () => {
                this.interval = setInterval(() => {
                    if (this.pause) return;
                    var a = this.audio.o2.timePoints
                        .filter(
                            (k) => k.timeSeconds <= this.audio.o2.audio.currentTime * 1000
                        )
                        .reverse()[0];

                    this.currentIndex = a ? parseInt(a.markName) : 0;
                }, 5);
            };

            var res = await this.getTts(
                this.question.options[2].title.join(" "),
                this.question.id,
                "o3"
            );

            this.audio.o3.timePoints = _.orderBy(
                res.data.timepoints.map((k) => {
                    return {
                        ...k,
                        timeSeconds: k.timeSeconds * 1000,
                        markName: parseInt(k.markName),
                    };
                }),
                ["markName"],
                ["ASC"]
            );
            this.audio.o3.audio = new Audio(
                "data:audio/mp3;base64," + res.data.sound
            );

            this.audio.o3.audio.onloadedmetadata = () => {
                this.totalDuration += this.audio.o3.audio.duration;
            };

            this.audio.o3.audio.onended = () => {
                this.currentPart += 1;
                this.currentIndex = 0;
                clearInterval(this.interval);
                this.interval = null;
                this.audio.o4.audio.play();
            };
            this.audio.o3.audio.onplay = () => {
                this.interval = setInterval(() => {
                    if (this.pause) return;
                    var a = this.audio.o3.timePoints
                        .filter(
                            (k) => k.timeSeconds <= this.audio.o3.audio.currentTime * 1000
                        )
                        .reverse()[0];

                    this.currentIndex = a ? parseInt(a.markName) : 0;
                }, 5);
            };

            var res = await this.getTts(
                this.question.options[3].title.join(" "),
                this.question.id,
                "o4"
            );

            this.audio.o4.timePoints = _.orderBy(
                res.data.timepoints.map((k) => {
                    return {
                        ...k,
                        timeSeconds: k.timeSeconds * 1000,
                        markName: parseInt(k.markName),
                    };
                }),
                ["markName"],
                ["ASC"]
            );
            this.audio.o4.audio = new Audio(
                "data:audio/mp3;base64," + res.data.sound
            );

            this.audio.o4.audio.onloadedmetadata = () => {
                this.totalDuration += this.audio.o4.audio.duration;
            };

            this.audio.o4.audio.onended = () => {
                this.currentPart += 1;
                this.currentIndex = 0;
                clearInterval(this.interval);
                this.interval = null;
                if (this.question.options[4] && this.question.options[4].title) {
                } else {
                    this.start();
                }
            };
            this.audio.o4.audio.onplay = () => {
                this.interval = setInterval(() => {
                    if (this.pause) return;
                    var a = this.audio.o4.timePoints
                        .filter(
                            (k) => k.timeSeconds <= this.audio.o4.audio.currentTime * 1000
                        )
                        .reverse()[0];

                    this.currentIndex = a ? parseInt(a.markName) : 0;
                }, 5);
            };

            if (this.question.options[4] && this.question.options[4].title) {
                var res = await this.getTts(
                    this.question.options[4].title.join(" "),
                    this.question.id,
                    "o5"
                );

                this.audio.o5.timePoints = res.data.timepoints.map((k) => {
                    return {
                        ...k,
                        timeSeconds: k.timeSeconds * 1000,
                        markName: parseInt(k.markName),
                    };
                });
                this.audio.o5.audio = new Audio(
                    "data:audio/mp3;base64," + res.data.sound
                );

                this.audio.o5.audio.onloadedmetadata = () => {
                    this.totalDuration += this.audio.o5.audio.duration;
                };

                this.audio.o5.audio.onended = () => {
                    this.currentPart += 1;
                    this.currentIndex = 0;
                    clearInterval(this.interval);
                    this.interval = null;
                    this.start();
                };
                this.audio.o5.audio.onplay = () => {
                    this.interval = setInterval(() => {
                        if (this.pause) return;
                        var a = this.audio.o5.timePoints
                            .filter(
                                (k) => k.timeSeconds <= this.audio.o5.audio.currentTime * 1000
                            )
                            .reverse()[0];

                        this.currentIndex = a ? parseInt(a.markName) : 0;
                    }, 5);
                };
            }

            if (this.titleFirst) {
                this.audio.title2.audio.play();
            } else {
                this.audio.description.audio.play();
            }
            setTimeout(() => {
                this.lock = false;
            }, 0);
        },
    },
    computed: {
        currentSpeed() {
            return this.speeds[this.speed - 1];
        },
    },
    watch: {
        pause: function () {
            if (this.pause === true) {
                if (this.currentPart == 0) {
                    this.audio.title2.audio.pause();
                }
                if (this.currentPart == 2) {
                    this.audio.title.audio.pause();
                }
                if (this.currentPart == 1) {
                    this.audio.description.audio.pause();
                }
                if (this.currentPart == 3) {
                    this.audio.o1.audio.pause();
                }
                if (this.currentPart == 4) {
                    this.audio.o2.audio.pause();
                }
                if (this.currentPart == 5) {
                    this.audio.o3.audio.pause();
                }
                if (this.currentPart == 6) {
                    this.audio.o4.audio.pause();
                }
                if (this.currentPart == 7) {
                    this.audio.o5.audio.pause();
                }
            } else {
                if (this.currentPart == 0) {
                    this.audio.title2.audio.play();
                }
                if (this.currentPart == 2) {
                    this.audio.title.audio.play();
                }
                if (this.currentPart == 1) {
                    this.audio.description.audio.play();
                }
                if (this.currentPart == 3) {
                    this.audio.o1.audio.play();
                }
                if (this.currentPart == 4) {
                    this.audio.o2.audio.play();
                }
                if (this.currentPart == 5) {
                    this.audio.o3.audio.play();
                }
                if (this.currentPart == 6) {
                    this.audio.o4.audio.play();
                }
                if (this.currentPart == 7) {
                    this.audio.o5.audio.play();
                }
            }
        },
        read: function () {
            if (this.read === false) {
                if (this.audio.title.audio) {
                    this.audio.title.audio.volume = 0;
                    this.audio.description.audio.volume = 0;
                    this.audio.o1.audio.volume = 0;
                    this.audio.o2.audio.volume = 0;
                    this.audio.o3.audio.volume = 0;
                    this.audio.o4.audio.volume = 0;
                    if (this.question.options[4] && this.question.options[4].title) {
                        this.audio.o5.audio.volume = 0;
                    }
                }
            } else {
                this.audio.title.audio.volume = 1;
                this.audio.description.audio.volume = 1;
                this.audio.o1.audio.volume = 1;
                this.audio.o2.audio.volume = 1;
                this.audio.o3.audio.volume = 1;
                this.audio.o4.audio.volume = 1;
                if (this.question.options[4] && this.question.options[4].title) {
                    this.audio.o5.audio.volume = 1;
                }
            }
        },
        currentSpeed: function () {
            clearTimeout(this.lockTimeout);
            this.lockTimeout = null;

            this.lockTimeout = setTimeout(() => {
                this.start();
            }, 1000);
        },
        titleFirst: function () {
            clearTimeout(this.lockTimeout);
            this.lockTimeout = null;

            this.lockTimeout = setTimeout(() => {
                this.start();
            }, 1000);
        },
        showingWordCount: function () {
            clearTimeout(this.lockTimeout);
            this.lockTimeout = null;

            this.lockTimeout = setTimeout(() => {
                this.start();
            }, 1000);
        },
    },
    async created() {
        var questions = (await axios.get("module/jobcontent")).data.data;

        questions.map((k) => {
            var options = [];

            for (let index = 1; index < 6; index++) {
                if (k["o" + index] != null && k["o" + index] != "") {
                    options.push({
                        title: k["o" + index]
                            .replace(/\s\s+/g, " ")
                            .replace(/[\n\r]/g, "")
                            .trim()
                            .split(" ")
                            .filter((k) => k.trim() != ""),
                        isTrue: k.true_option == "o" + index,
                    });
                }
            }

            this.words.push({
                ...k,
                id: k.question_id,
                title: k.title
                    .replace(/\s\s+/g, " ")
                    .replace(/[\n\r]/g, "")
                    .trim()
                    .split(" ")
                    .filter((k) => k.trim() != ""),
                description: k.description
                    .replace(/\s\s+/g, " ")
                    .replace(/[\n\r]/g, "")
                    .trim()
                    .split(" ")
                    .filter((k) => k.trim() != ""),
                options,
            });
        });

        this.start();

        if (this.config != null && this.config != undefined) {
            if (this.config.level != null && this.config.level != "")
                this.level = this.config.level;
            if (this.config.speed != null && this.config.speed != "")
                this.speed = this.config.speed;
            this.autoLevel = this.config.auto_level;
        }
    },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
    width: 700px;
    height: auto;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    background: white;
    background-color: #ffffff;
    background-image: url("https://www.transparenttextures.com/patterns/45-degree-fabric-light.png");
    margin-top: 60px;

    ol {
        margin: 0px;
        padding: 0px;
        padding-left: 15px;

        li {
            cursor: pointer;

            &:hover {
                background: white;
            }
        }
    }
}
</style>

<style>
.el-select-dropdown {
    z-index: 9999999 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/JobGolgeliOkuma.vue